// extracted by mini-css-extract-plugin
export default {"popup":"unsaved-dialog_popup__cM3AZ"};